import './SMPsite.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class SMPsite extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

}
